export default __webpack_public_path__ + "static/media/trener2.aa413525.png";